/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { decodeJWT } from '../decodeJWT';

/**
 * Sees whether a JWT has already expired
 *
 * @param {String} token The token string to parse.
 * @returns {Boolean} Whether the token has already expired
 */
export const isTokenExpired = (token) => {
  const tokenExpiration = decodeJWT(token).exp * 1000;
  const hasExpired = tokenExpiration < Date.now();
  return hasExpired;
};
